export default "__VITE_ASSET__$S89zP1S__"